var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"bg-ontick-carbon-400 border-none",class:[_vm.activeColor, { checked: _vm.active }, { 'cursor-not-allowed': _vm.disabled }],attrs:{"role":"checkbox","aria-checked":_vm.active,"disabled":_vm.disabled},on:{"click":function($event){$event.stopPropagation();return _vm.changeValue.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }